<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    active: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<template>
  <div class="item"  :class="{active: active}">
    <div class="label">{{item.Name}}</div>
    <div class="logo"></div>
  </div>
</template>

<style scoped lang="stylus">
@import '~common/stylus/variable'
@import '~common/stylus/base'
.item{
  @extend .flex-start;
  width: 100%;
  min-height: 56px;
  position: relative;
  &:after{
    position: absolute;
    left: 12px;
    bottom: 0;
    width: calc(100% - 12px);
    height: 0;
    content: ' ';
    border-bottom: 0.5px solid $color_black_30;
  }
  &.active{
    >.label{
      color: $color_theme_300;
    }
    >.logo{
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      margin: auto 12px;
      background-image: url('@/assets/image/base/check-box/icons_16pt_right.png');
      background-size: 100% 100%;
    }
  }
  >.label{
    @extend .flex-start;
    @extend .hs-font-body;
    width: 100%;
    padding: 8px 12px;
    >span{
      color: $color_black_100;
      margin-left: 8px;
    }
  }
}
</style>
